export default __webpack_public_path__ + "static/media/add-grey.721ee8e4.svg";